import { computed } from 'vue'
import { useAppStateStore } from '@/features/application'
import { ROUTE_RESET_IMPERSO } from '@/features/auth/impersonnalisation'
import { useDemandeRattachement } from '@/features/interface/profil-utilisateur/sections/rattachements/demande'
import { Utilisateur } from '@/features/auth'
import router from '@/router'
import { navigateTo } from '@/router/navigateTo'

export function useNavigationAction(onClose: () => void) {
  const appState = useAppStateStore()

  const fullName = computed(() => appState.utilisateur?.prenomNomAffichage)

  const fullNameInterne = computed(() => {
    return appState.utilisateur instanceof Utilisateur ? appState.utilisateur.prenomNomInterne : ''
  })

  function changerUtilisateur() {
    router.push({ name: ROUTE_RESET_IMPERSO }).finally(onClose)
  }

  function redirectionProfil() {
    navigateTo({ to: 'utilisateur', module: 'profil' }).finally(onClose)
  }

  function demanderRattachement() {
    const demandeRattachement = useDemandeRattachement()
    demandeRattachement.showDialog()
    onClose()
  }

  return {
    appState,
    fullName,
    fullNameInterne,
    onClose,
    redirectionProfil,
    changerUtilisateur,
    demanderRattachement,
  }
}
